module.exports = __webpack_public_path__ + "static/media/KMH_5273.b86e6c19.jpg";